module.exports = __webpack_public_path__ + "static/media/downloadIcon.68edf532.svg";